export type MediaType = "image" | "video" | "document" | "audio";

export const EXTENSION_MAP: Record<string, MediaType> = {
  jpg: "image",
  jpeg: "image",
  png: "image",
  webp: "image",
  gif: "image",
  mp4: "video",
  mov: "video",
  pdf: "document",
  doc: "document",
  docx: "document",
  xls: "document",
  xlsx: "document",
  mp3: "audio",
  ogg: "audio",
  wav: "audio",
};

export const inferMediaType = (
  url: string,
  explicitType?: string,
): MediaType => {
  if (explicitType && explicitType !== "auto") return explicitType as MediaType;
  const ext = url.split(".").pop()?.toLowerCase()?.split("?")[0] || "";
  return EXTENSION_MAP[ext] || "document";
};
